export const HISTORY_PUSH_REQUEST = 'history/HISTORY_PUSH_REQUEST'



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/history/actionTypes.ts